import { ThemeUIStyleObject } from "theme-ui"

export const spacingNoneStyles: ThemeUIStyleObject = {
  my: [0],
  py: [0],
}

export const spacingDefaultStyles: ThemeUIStyleObject = {
  my: [6, 9, 11], // 30, 45, 60
}
export const spacingSmStyles: ThemeUIStyleObject = {
  my: [4, 6, 8], // 20, 30, 40
}
export const spacingMdStyles: ThemeUIStyleObject = {
  my: [8, 11, 13], // 40, 60, 80
}
export const spacingLgStyles: ThemeUIStyleObject = {
  my: [13, 15, 17], // 80, 100, 120
}

export const spacingWithBgColorDefaultStyles: ThemeUIStyleObject = {
  py: [6, 9, 11], // 30, 45, 60
}
export const spacingWithBgColorSmStyles: ThemeUIStyleObject = {
  py: [4, 6, 8], // 20, 30, 40
}
export const spacingWithBgColorMdStyles: ThemeUIStyleObject = {
  py: [8, 11, 13], // 40, 60, 80
}
export const spacingWithBgColorLgStyles: ThemeUIStyleObject = {
  py: [13, 15, 17], // 80, 100, 120
}

export const bgLighterGrayStyles: ThemeUIStyleObject = {
  bg: "lighterGray",
}
export const bgRedStyles: ThemeUIStyleObject = {
  bg: "darkRed",
}
export const bgGreenStyles: ThemeUIStyleObject = {
  bg: "darkGreen",
}
export const bgWhiteStyles: ThemeUIStyleObject = {
  bg: "white",
}

export const whiteTopBorderSeperator: ThemeUIStyleObject = {
  borderTop: ["15px solid white", "30px solid white", "30px solid white"],
}

export const moduleStyles: ThemeUIStyleObject = {
  position: "relative",
  zIndex: 1,
}

export const bgRedToGrayStyles: ThemeUIStyleObject = {
  bg: "darkRed",
  position: "relative",
  ":after": {
    content: "''",
    position: "absolute",
    left: 0,
    bottom: 0,
    height: "30%",
    maxHeight: "250px",
    width: "100%",
    bg: "lightGray",
    zIndex: 0,
  },
}

export const bgGreenToGrayStyles: ThemeUIStyleObject = {
  bg: "darkGreen",
  position: "relative",
  ":after": {
    content: "''",
    position: "absolute",
    left: 0,
    bottom: 0,
    height: "30%",
    maxHeight: "250px",
    width: "100%",
    bg: "lightGray",
    zIndex: 0,
  },
}
